import React from "react";
import Button from "@material-ui/core/Button";

export default function (props) {
  return <Button variant="outlined" color="secondary" {...props} />;
}
